import React from "react";
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Header.css';


const Header = () => {

    
    return (
        <div>
            <div>
                <h1>Avec qui j'aimerais discuter ?</h1>
            </div>
        <Container className="header">
            <Row style={{textAlign:"center"}}>
                <Col>
                    <Button className="btn btn-secondary" style={{backgroundColor:"#32afb2", border:"none", fontWeight:"bold"}}><Link to="/Components/IndexAuteurs" style={{textDecoration:"none", color:"white"}}>Écrivains</Link></Button>
                    <Button className="btn btn-secondary" style={{backgroundColor:"#32afb2", border:"none", fontWeight:"bold"}}><Link to="/Components/IndexPoetes" style={{textDecoration:"none", color:"white"}}>Poètes</Link></Button>
                    <Button className="btn btn-secondary" style={{backgroundColor:"#32afb2", border:"none", fontWeight:"bold"}}><Link to="/Components/IndexChanteurs" style={{textDecoration:"none", color:"white"}}>Chanteurs</Link></Button>
                    <Button className="btn btn-secondary" style={{backgroundColor:"#32afb2", border:"none", fontWeight:"bold"}}><Link to="/" style={{textDecoration:"none", color:"white"}}>Afficher tous</Link></Button>
                </Col>
            </Row>
        </Container>
    </div>
    )
}

export default Header;